export const SUPPORTED_LANGUAGES = ['en', 'et', 'ru', 'lv', 'lt'];

export const emptyTranslation = () => Object.fromEntries(SUPPORTED_LANGUAGES.map((lang) => [lang, '']));

export const normalizeTranslation = (value) =>
  Object.fromEntries(SUPPORTED_LANGUAGES.map((lang) => [lang, value?.[lang] ?? '']));
